import { render, staticRenderFns } from "./quiz-pressure.vue?vue&type=template&id=b826ab40&scoped=true"
import script from "./quiz-pressure.vue?vue&type=script&lang=js"
export * from "./quiz-pressure.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b826ab40",
  null
  
)

export default component.exports